import { render, staticRenderFns } from "./FrequencyCap.vue?vue&type=template&id=44e3dbab&scoped=true&"
import script from "./FrequencyCap.vue?vue&type=script&lang=ts&"
export * from "./FrequencyCap.vue?vue&type=script&lang=ts&"
import style0 from "./FrequencyCap.vue?vue&type=style&index=0&id=44e3dbab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e3dbab",
  null
  
)

export default component.exports